import React from 'react';
import PageHeader from '../components/layout/PageHeader';
import { CrownIcon, MapPinIcon, BookOpenIcon, UsersIcon, LandmarkIcon, CalendarIcon } from 'lucide-react';
import Button from '../components/ui/Button';
const IsonyinCommunity = () => {
  const baales = [{
    name: 'Oso',
    number: 1
  }, {
    name: 'Kujeyiro',
    number: 2
  }, {
    name: 'Ogunkelu',
    number: 3
  }, {
    name: 'Ifelaja',
    number: 4
  }, {
    name: 'Liwobanjoko',
    number: 5
  }, {
    name: 'Ogunyimika',
    number: 6
  }, {
    name: 'Okusan',
    number: 7
  }, {
    name: 'Fasina',
    number: 8
  }, {
    name: 'Sanni Kudojo',
    number: 9
  }, {
    name: 'Ogunnowo (Alafia)',
    number: 10
  }, {
    name: 'Osituyo',
    number: 11
  }, {
    name: 'Animasaun',
    number: 12
  }];
  const rulingHouses = [{
    name: 'Sade/Kobode',
    quarters: 'Itun Ogun Quarters'
  }, {
    name: 'Tunwase',
    quarters: 'Eyindi Quarters'
  }, {
    name: 'Edagunnodo',
    quarters: 'Idotun & Odogunnodo Quarters'
  }, {
    name: 'Sapenuwa',
    quarters: 'Itun Isonyin Quarters'
  }];
  const obas = [{
    name: 'H.R.H Oba A. K. A. Ogunnuga',
    title: 'Olumoyebo I',
    house: 'Sade/Kobode Ruling House',
    period: '1989 - 2002'
  }, {
    name: "H.R.H Oba 'Funso Omo-Ogunkoya",
    title: 'Tunwase I',
    house: 'Tunwase Ruling House',
    period: '2005 - 2015'
  }, {
    name: 'H.R.H Oba AbdulRasheed Omotayo Cosy Salami',
    title: 'Ilufemiloye I',
    house: 'Edagunnodo Ruling House',
    period: '2016 to Date'
  }];
  return <div className="min-h-screen bg-white" data-id="element-5387">
      <PageHeader title="The Isonyin Community" description="Discover the rich history and heritage of Isonyin, from its founding to modern day." backgroundImage="https://uploadthingy.s3.us-west-1.amazonaws.com/p5ChseGrCyEaSZ3ujV6kfx/WhatsApp_Image_2025-10-24_at_10.01.13_%282%29.jpg" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'About',
      path: '/about'
    }, {
      label: 'Isonyin Community',
      path: '/isonyin-community'
    }]} data-id="element-5388" />
      <div className="container mx-auto px-4 py-12" data-id="element-5389">
        {/* Introduction Section */}
        <section className="mb-16" data-id="element-5390">
          <div className="text-center mb-10" data-id="element-5391">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5392">
              Brief History of Isonyin
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5393"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-12" data-id="element-5394">
            <div data-id="element-5395">
              <div className="inline-block p-3 bg-blue-100 rounded-full mb-4" data-id="element-5396">
                <MapPinIcon className="h-6 w-6 text-blue-700" data-id="element-5397" />
              </div>
              <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-5398">
                Location & Founding
              </h3>
              <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-5399">
                Isonyin is a town about five kilometers from Ijebu-Ode, located
                in Ijebu North East Local Government Area of Ogun State. The
                town was founded during the migration of Obanta to Ijebu-Ode
                from Ile-Ife.
              </p>
              <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-5400">
                One of the princesses and assuredly one of the ablest women who
                accompanied Obanta on this long and hazardous journey was{' '}
                <span className="font-bold text-blue-900" data-id="element-5401">Riren Lewa</span>. She
                and her followers stayed for a short while at Odo-Esa in
                Ijebu-Ode and later moved to Isonyin where they finally settled.
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-5402">
                As the people arrived in their new settlement, two small areas
                were occupied and later named{' '}
                <span className="font-semibold" data-id="element-5403">Itun Ogun</span> and{' '}
                <span className="font-semibold" data-id="element-5404">Itun Isonyin</span>. At these
                places were built shrines for the traditional religion.
              </p>
            </div>
            <div className="rounded-lg overflow-hidden shadow-xl" data-id="element-5405">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2pvKeq1xRDYyrmpAoRh9MF/WhatsApp_Image_2025-11-07_at_19.21.03_%282%29.jpg" alt="Aafin Saderiren Palace Entrance" className="w-full h-auto" data-id="element-5406" />
            </div>
          </div>
        </section>
        {/* Origin of the Name Section */}
        <section className="mb-16" data-id="element-5407">
          <div className="bg-gradient-to-br from-yellow-500 to-yellow-400 rounded-lg overflow-hidden" data-id="element-5408">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-0" data-id="element-5409">
              <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-5410">
                <div className="inline-block p-3 bg-blue-900/20 rounded-full w-fit mb-6" data-id="element-5411">
                  <BookOpenIcon className="h-8 w-8 text-blue-900" data-id="element-5412" />
                </div>
                <h2 className="text-3xl font-bold text-blue-900 mb-4" data-id="element-5413">
                  The Meaning of "Isonyin"
                </h2>
                <p className="text-blue-900 mb-6 leading-relaxed" data-id="element-5414">
                  The meaning and origin of the word Isonyin is derived from the
                  Ijebu word <span className="font-bold" data-id="element-5415">"S'oyinnu"</span>{' '}
                  meaning "to be mirthful, to be jovial, to be festive and to be
                  happy."
                </p>
                <div className="bg-blue-900 text-white p-6 rounded-lg mb-4" data-id="element-5416">
                  <p className="text-lg italic mb-2" data-id="element-5417">
                    "A s'oyinnu do si ibi yi"
                  </p>
                  <p className="text-sm" data-id="element-5418">
                    "We are happy or mirth to settle here"
                  </p>
                </div>
                <p className="text-blue-900 leading-relaxed" data-id="element-5419">
                  When the settlers had trekked from Ijebu-Ode to this site,
                  they were satisfied with the location after assessing all
                  necessary prerequisites for settlement. From this expression
                  emerged the name{' '}
                  <span className="font-bold" data-id="element-5420">Isonyinnudo</span>, later
                  contracted to <span className="font-bold" data-id="element-5421">Isonyin</span>, the
                  name by which the settlement founded by Riren Lewa and her
                  followers is called today.
                </p>
              </div>
              <div className="relative h-full min-h-[400px]" data-id="element-5422">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wM9KZAdD4NfUn6Kc3kQQPL/WhatsApp_Image_2025-11-07_at_19.21.03_%281%29.jpg" alt="Palace Entrance Gate" className="w-full h-full object-cover" data-id="element-5423" />
              </div>
            </div>
          </div>
        </section>
        {/* Traditional Leadership - Baales Section */}
        <section className="mb-16" data-id="element-5424">
          <div className="text-center mb-10" data-id="element-5425">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5426">
              Successive Baales of Isonyin
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5427"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-5428">
              Traditional rulers from the time of introduction of the new title
              from Otunbas
            </p>
          </div>
          <div className="bg-blue-50 p-8 rounded-lg" data-id="element-5429">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-5430">
              {baales.map(baale => <div key={baale.number} className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow" data-id="element-5431">
                  <div className="flex items-center" data-id="element-5432">
                    <div className="bg-blue-900 text-white font-bold rounded-full w-12 h-12 flex items-center justify-center mr-4" data-id="element-5433">
                      {baale.number}
                    </div>
                    <div data-id="element-5434">
                      <h3 className="font-bold text-blue-900" data-id="element-5435">
                        Baale {baale.name}
                      </h3>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
        {/* Journey to Obaship Section */}
        <section className="mb-16" data-id="element-5436">
          <div className="text-center mb-10" data-id="element-5437">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5438">
              The Journey to Obaship
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5439"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center mb-12" data-id="element-5440">
            <div className="rounded-lg overflow-hidden shadow-xl" data-id="element-5441">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/67rct2SDFUjiq5JZTUhbEf/WhatsApp_Image_2025-11-07_at_19.21.03.jpg" alt="Royal Throne and Regalia" className="w-full h-auto" data-id="element-5442" />
            </div>
            <div data-id="element-5443">
              <h3 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-5444">
                Evolution of Traditional Leadership
              </h3>
              <div className="space-y-4" data-id="element-5445">
                <div className="flex items-start" data-id="element-5446">
                  <CalendarIcon className="h-5 w-5 text-blue-700 mr-3 mt-1 flex-shrink-0" data-id="element-5447" />
                  <div data-id="element-5448">
                    <p className="font-bold text-blue-900" data-id="element-5449">1931</p>
                    <p className="text-gray-700" data-id="element-5450">
                      First move to change to Obaship was initiated during the
                      reign of Baale Banjoko. However, Baale Banjoko joined his
                      ancestors in 1937 before the transition could be
                      completed.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-5451">
                  <CalendarIcon className="h-5 w-5 text-blue-700 mr-3 mt-1 flex-shrink-0" data-id="element-5452" />
                  <div data-id="element-5453">
                    <p className="font-bold text-blue-900" data-id="element-5454">1984</p>
                    <p className="text-gray-700" data-id="element-5455">
                      The new move was initiated by the then Olori-Ilu Chief
                      Alhaji Animasun in collaboration with others during the
                      reign of Baale Osituyo. It was proposed that the title of
                      Baale should be abolished and that of an Oba be
                      substituted.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-5456">
                  <CalendarIcon className="h-5 w-5 text-blue-700 mr-3 mt-1 flex-shrink-0" data-id="element-5457" />
                  <div data-id="element-5458">
                    <p className="font-bold text-blue-900" data-id="element-5459">1998</p>
                    <p className="text-gray-700" data-id="element-5460">
                      The road to Obaship was formally initiated. Four ruling
                      houses were created to ensure fair rotation of the
                      traditional leadership position.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Ruling Houses Section */}
        <section className="mb-16" data-id="element-5461">
          <div className="text-center mb-10" data-id="element-5462">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5463">
              The Four Ruling Houses
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5464"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-5465">
              Established in 1998 to ensure fair rotation of leadership
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5466">
            {rulingHouses.map((house, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-md border border-gray-200 hover:shadow-lg transition-shadow" data-id="element-5467">
                <div className="flex items-start" data-id="element-5468">
                  <div className="bg-yellow-500 p-3 rounded-full mr-4 flex-shrink-0" data-id="element-5469">
                    <CrownIcon className="h-6 w-6 text-blue-900" data-id="element-5470" />
                  </div>
                  <div data-id="element-5471">
                    <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-5472">
                      {house.name}
                    </h3>
                    <p className="text-gray-700" data-id="element-5473">{house.quarters}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </section>
        {/* Isonyin Obas Section */}
        <section className="mb-16" data-id="element-5474">
          <div className="text-center mb-10" data-id="element-5475">
            <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5476">
              Isonyin Obas (Class II)
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5477"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-5478">
              The traditional rulers who have led Isonyin since the
              establishment of Obaship
            </p>
          </div>
          <div className="space-y-6" data-id="element-5479">
            {obas.map((oba, index) => <div key={index} className="bg-gradient-to-r from-blue-900 to-blue-800 text-white rounded-lg overflow-hidden shadow-xl" data-id="element-5480">
                <div className="p-8" data-id="element-5481">
                  <div className="flex items-start mb-4" data-id="element-5482">
                    <div className="bg-yellow-500 text-blue-900 font-bold rounded-full w-12 h-12 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-5483">
                      {index + 1}
                    </div>
                    <div className="flex-grow" data-id="element-5484">
                      <h3 className="text-2xl font-bold mb-2" data-id="element-5485">{oba.name}</h3>
                      <p className="text-yellow-300 text-xl mb-2" data-id="element-5486">
                        {oba.title}
                      </p>
                      <p className="text-blue-200 mb-2" data-id="element-5487">{oba.house}</p>
                      <div className="flex items-center text-gray-300" data-id="element-5488">
                        <CalendarIcon className="h-4 w-4 mr-2" data-id="element-5489" />
                        <span data-id="element-5490">{oba.period}</span>
                      </div>
                    </div>
                  </div>
                  {index === obas.length - 1 && <div className="mt-6 pt-6 border-t border-blue-700" data-id="element-5491">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center" data-id="element-5492">
                        <div data-id="element-5493">
                          <p className="text-gray-200 leading-relaxed" data-id="element-5494">
                            His Royal Majesty Oba AbdulRasheed Omotayo Cosy
                            Salami, Ilufemiloye I, currently serves as the
                            Saderiren of Isonyin-Ijebu. His leadership has been
                            instrumental in the continued development of Isonyin
                            and the support of educational institutions like
                            Isonyin Grammar School.
                          </p>
                        </div>
                        <div className="rounded-lg overflow-hidden" data-id="element-5495">
                          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pmzWxqTAFiVfAqyLvLN9nE/WhatsApp_Image_2025-11-07_at_19.21.02.jpg" alt="Current Oba in Traditional Regalia" className="w-full h-auto" data-id="element-5496" />
                        </div>
                      </div>
                    </div>}
                </div>
              </div>)}
          </div>
        </section>
        {/* Cultural Heritage Section */}
        <section className="mb-16" data-id="element-5497">
          <div className="bg-blue-50 p-8 rounded-lg border border-blue-100" data-id="element-5498">
            <div className="text-center mb-8" data-id="element-5499">
              <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-5500">
                Cultural Heritage & Community
              </h2>
              <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-5501"></div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-5502">
              <div className="bg-white p-6 rounded-lg shadow-sm text-center" data-id="element-5503">
                <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-5504">
                  <LandmarkIcon className="h-8 w-8 text-blue-700" data-id="element-5505" />
                </div>
                <h3 className="font-bold text-blue-900 mb-2" data-id="element-5506">
                  Traditional Institution
                </h3>
                <p className="text-gray-700 text-sm" data-id="element-5507">
                  A strong traditional leadership system that has guided the
                  community through generations of growth and development.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm text-center" data-id="element-5508">
                <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-5509">
                  <UsersIcon className="h-8 w-8 text-blue-700" data-id="element-5510" />
                </div>
                <h3 className="font-bold text-blue-900 mb-2" data-id="element-5511">
                  Community Unity
                </h3>
                <p className="text-gray-700 text-sm" data-id="element-5512">
                  A close-knit community that works together for the collective
                  progress and welfare of all its members.
                </p>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm text-center" data-id="element-5513">
                <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-5514">
                  <BookOpenIcon className="h-8 w-8 text-blue-700" data-id="element-5515" />
                </div>
                <h3 className="font-bold text-blue-900 mb-2" data-id="element-5516">
                  Educational Excellence
                </h3>
                <p className="text-gray-700 text-sm" data-id="element-5517">
                  Home to Isonyin Grammar School since 1956, producing leaders
                  and professionals who contribute to national development.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Call to Action */}
        <section className="bg-gradient-to-r from-blue-900 to-blue-800 text-white rounded-lg overflow-hidden" data-id="element-5518">
          <div className="container mx-auto px-4 py-12" data-id="element-5519">
            <div className="text-center" data-id="element-5520">
              <h2 className="text-3xl font-bold mb-4" data-id="element-5521">
                Learn More About Isonyin
              </h2>
              <p className="max-w-2xl mx-auto mb-8 leading-relaxed" data-id="element-5522">
                Discover more about the rich heritage, educational institutions,
                and cultural significance of the Isonyin community.
              </p>
              <div className="flex flex-wrap justify-center gap-4" data-id="element-5523">
                <Button href="/about" variant="primary" data-id="element-5524">
                  About Our School
                </Button>
                <Button href="/town-history" variant="outline" className="border-white text-white hover:bg-white/10" data-id="element-5525">
                  Town History
                </Button>
                <Button href="/contact" variant="outline" className="border-white text-white hover:bg-white/10" data-id="element-5526">
                  Contact Us
                </Button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>;
};
export default IsonyinCommunity;